/* jshint esversion: 6 */
const padLeftZero = (str) => `00${str}`.substr(str.length);

//时间戳转换string
export function formatDate(date, fmt) {
  if (!date || typeof date !== "object") {
    return "";
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  const o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`;
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  });
  return fmt;
}

// 钱
export function currency(v, c, d) {
  v = parseFloat(v);
  if (!isFinite(v) || (!v && v !== 0)) return "";
  c = c != null ? c : "¥";
  d = d != null ? d : 2;
  const digitsRE = /(\d{3})(?=\d)/g; // \d =[0~9],{3}匹配3次，
  const stringified = Math.abs(v).toFixed(d); // 保留2位小数
  const int = d ? stringified.slice(0, -1 - d) : stringified; // 取整
  const i = int.length % 3; //= >1
  const head = i > 0 ? int.slice(0, i) + (int.length > 3 ? "," : "") : ""; // 2,
  const float = d ? stringified.slice(-1 - d) : ""; // .20
  const sign = v < 0 ? "-" : "";
  return sign + c + head + int.slice(i).replace(digitsRE, "$1,") + float;
}

// 星号替换
export function plusXing(str, star, frontLen, endLen) {
  str = str.toString();
  star = star != null ? star : 3;
  frontLen = frontLen != null ? frontLen : 3;
  endLen = endLen != null ? endLen : 3;
  let xing = "";
  for (let i = 0; i < star; i += 1) {
    xing += "*";
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}

// 隐藏手机号中间四位
export function hideMobileMiddle(mobile) {
  if (!mobile) return '';
  // 将手机号第4到7位替换为星号
  return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

// 小数点前
export function pointBefore(price) {
  return (price + "").split(".")[0];
}
// 小数点后
export function pointAfter(price) {
  const val = (price + "").split(".")[1];
  if (!val) {
    return "00";
  } else if (val.length === 1) {
    return val + "0";
  } else {
    return val;
  }
}

// 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getDistance(lat1, lng1, lat2, lng2) {
  try {
    var radLat1 = (lat1 * Math.PI) / 180.0;
    var radLat2 = (lat2 * Math.PI) / 180.0;
    var a = radLat1 - radLat2;
    var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137; // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000; //输出为公里
    console.log("s====", s);

    if (parseInt(s) >= 1) {
      s = s.toFixed(2) + "km";
    } else {
      s = (s * 1000).toFixed(1) + "m";
    }
    return s;
  } catch (error) {
    return "";
  }
}
function Rad(d) {
  return (d * Math.PI) / 180.0;
}

export function distanceByLnglat(lng1, lat1, lng2, lat2) {
  try {
    var radLat1 = Rad(lat1);
    var radLat2 = Rad(lat2);
    var a = radLat1 - radLat2;
    var b = Rad(lng1) - Rad(lng2);
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378137.0; // 取WGS84标准参考椭球中的地球长半径(单位:m)
    s = Math.round(s * 10000) / 10000;
    var n = "";
    if (s) {
      if (s >= 1000) {
        n = (s / 1000).toFixed(2) + "km";
      } else {
        n = s.toFixed(2) + "m";
      }
    } else {
      n = "0m";
    }
    return n;
    // if (parseInt(s) >= 1) {
    //   s = s.toFixed(2) + "km";
    // } else {
    //   s = (s * 1000).toFixed(1) + "m";
    // }
    // return s;
  } catch (error) {
    return "";
  }
}
export function replaceImg(url, d) {
  d = d ? d : "sl";
  if (!url) return "";
  return url.replace(/[(.*)(_m)]\./, d + ".");
}
// 价格显示格式化
export function decimalPice(value = 0, decimal = 2) {
  // var regPos = /^([1-9][\d]{0,6}|0)(\.[\d]{1,4})?$/
  // if(regPos.test(value)){
  //   value = value.toString();
  // }else{
  //   value = '0';
  // }
  if (!value || value == 'undefined') value = 0;
  value = value.toString();
  const index = value.indexOf(".");
  if (index !== -1) {
    value = value.substring(0, decimal + index + 1);
  } else {
    value = value.substring(0);
  }
  value = parseFloat(value)
    .toFixed(decimal)
    .split(".");
  return {
    integerDecimal: `${value[0]}.${value[1].substring(0, decimal)}`,
    integer: value[0],
    decimal: value[1].substring(0, decimal),
  };
}
